import CustomApplication from './CustomFormApplication';

export default CustomApplication;
